import "../../Assets/Scss/Company.scss"
import {Cards} from "./Components"

const CompanyPage = () => {
   
    return (
       <>
        <Cards/>
       </>
    );
}
 
export default CompanyPage;